import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import { useEffect, useState } from "react";
import { TostadorFetching } from "../../../class/fetchTostador";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import { useDate } from "../../../hooks/useDate";
import LoadingChart from "../../Home/components/loadingChart";

export default function CalcinaProducida() {
  // Objecto default del state
  const defaultObject = Object.assign({
    value: [],
    fecha: [],
  });

  // Peticion inicial de esta grafica
  const initialFetch = new TostadorFetching()
    .setIdSeccion(8)
    .setSecuencia(4)
    .setFrecuencia(720)
    .setDias(7);

  // Custom hook que nos ayuda a extraer la fecha inicial y final
  const { setDateHook, fullDate } = useDate();
  const [isLoading, setIsLoading] = useState(true);

  const [cutCalcinaProducida, setCutCalcinaProducida] = useState(defaultObject);
  const [leyCuPlanSemanalCalcina, setLeyCuPlanSemanalCalcina] =
    useState(defaultObject);
  const [asCalcinaProducida, setAsCalcinaProducida] = useState(defaultObject);
  const [leyAsPlanSemanalCalcina, setLeyAsPlanSemanalCalcina] =
    useState(defaultObject);
  const [sCalcinaProducida, setSCalcinaProducida] = useState(defaultObject);
  const [si02CalcinaProducida, setSi02CalcinaProducida] =
    useState(defaultObject);

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      const { data } = await getValoresPeriodo(initialFetch);
      setDateHook(data, "Calc_Prod_S");
      populateCutCalcinaProducida(data);
      populateLeyCuPlanSemanalCalcina(data);
      populateAsCalcinaProducida(data);
      populateLeyAsPlanSemanalCalcina(data);
      populateSCalcinaProducida(data);
      populatesio2CalcinaProducida(data);

      setTimeout(() => {
        fetchData();
      }, 300000);
      setIsLoading(false);
    }

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populatesio2CalcinaProducida(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter((element) => element.Detalle === "Calc_Prod_S");

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setSi02CalcinaProducida({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateSCalcinaProducida(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter((element) => element.Detalle === "Calc_Prod_S");

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setSCalcinaProducida({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateLeyAsPlanSemanalCalcina(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "LEY_AS_CALC.PS"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setLeyAsPlanSemanalCalcina({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateAsCalcinaProducida(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Calc_Prod_As"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setAsCalcinaProducida({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateLeyCuPlanSemanalCalcina(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "LEY_CU_CALC.PS"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setLeyCuPlanSemanalCalcina({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCutCalcinaProducida(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Calc_Prod_CuT"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setCutCalcinaProducida({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  return (
    <>
      {isLoading ? (
        <LoadingChart />
      ) : (
        <Card>
          <Card.Content>
            <Chart
              title="Calcina Producida - Reporte"
              subtitle={"Periodo " + fullDate()}
              zoom="x"
            >
              <Chart.Column
                name="%CuT Calcina Producida - Reporte"
                data={cutCalcinaProducida.value}
              />
              <Chart.Line
                name="Ley Cu Plan Semanal Calcina"
                data={leyCuPlanSemanalCalcina.value}
              />
              <Chart.Column
                name="%As Calcina Producida - Reporte"
                data={asCalcinaProducida.value}
                yAxis={1}
              />
              <Chart.Line
                name="Ley As Plan Semanal Calcina"
                data={leyAsPlanSemanalCalcina.value}
                yAxis={1}
              />
              <Chart.Column
                name="%S Calcina Producida - Reporte"
                data={sCalcinaProducida.value}
              />
              <Chart.Column
                name="%SiO2 Calcina Producida - Reporte"
                data={si02CalcinaProducida.value}
              />

              <Chart.XAxis
                allowDecimals={false}
                categories={cutCalcinaProducida.fecha}
              />
              <Chart.YAxis
                labelSuffix=" %"
                title="Conteido Cu - S, %"
                lineWidth={2}
                lineColor="white"
                min={0}
              />

              <Chart.YAxis
                labelSuffix=" %"
                title="Contenido As, %"
                lineWidth={2}
                opposite={true}
                lineColor="white"
                min={0}
              />
              <Chart.YAxis labelSuffix=" %" />
              <Chart.Tooltip valueSuffix=" %" />
            </Chart>
          </Card.Content>
        </Card>
      )}
    </>
  );
}
